module.exports = __webpack_public_path__ + "img/icon2.bfc5018e.png";